import { useState, useEffect, FC } from 'react';

import Typography from '@mui/material/Typography';
import {
    StarryBackground,
    StyledGrid,
    StyledButton,
    NebulaEffect,
    MenuContainer,
    HeaderContainer,
    TitleContainer,
    SubtitleContainer,
    ExitButton,
    Spacer,
} from './styled';
import LinearProgress from '@mui/material/LinearProgress';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import keycloak from '../../../keycloak';

const rmiacURL = process.env.REACT_APP_RMIAC as string;
const logoutURL = process.env.REACT_APP_API_URL as string;

const getWebServicesByRolesURL = process.env.REACT_APP_API_URL + '/user/userInfo';

const certificatesURL = process.env.REACT_APP_CERTIFICATES_URL;
const dispensaryURL = process.env.REACT_APP_DISPENSARY_URL;
const monitoringURL = process.env.REACT_APP_MONITORING_URL;

const menuItems = [
    { name: 'Мониторинг', icon: '📊', description: 'Система мониторинга', url: monitoringURL },
    { name: 'МедВид', icon: '🏥', description: 'Медицинские видео' },
    { name: 'Кадры', icon: '👥', description: 'Управление персоналом' },
    { name: 'ПрофОсмотр.Дети', icon: '👶', description: 'Детские осмотры' },
    { name: 'Справки.Дети', icon: '📋', description: 'Детские справки', url: certificatesURL },
    { name: 'Отчеты', icon: '📈', description: 'Отчетность' },
    { name: 'Регистр коморбидных', icon: '🛰️', description: 'Кабинет диспансерного наблюдения', url: dispensaryURL },
    { name: 'Опросы', icon: '📝', description: 'Анкетирование' },
    { name: 'Администрирование', icon: '⚙️', description: 'Настройки системы' },
];

const Main: FC<{
    getFioAndOrganization: (value: string) => void;
    handleLogOff: () => void;
    userRoles: string[];
}> = ({ getFioAndOrganization, handleLogOff, userRoles }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<
        | {
              id: number;
              systemName: string;
              displayName: string;
              description: string;
          }[]
        | null
    >(null);
    const [error, setError] = useState<string | {} | undefined>(undefined);

    const navigate = useNavigate();

    // Убираем скролл на уровне страницы
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    // useEffect(() => {
    //     setIsLoading(true);

    //     try {
    //         axios
    //             .get(getWebServicesByRolesURL, {
    //                 headers: { Authorization: `Bearer ${keycloak.token}` },
    //             })
    //             .then((data) => {
    //                 setData(data.data);
    //             })
    //             .catch((err) => {
    //                 if (err.response.status === 401) {
    //                     localStorage.clear();
    //                     getFioAndOrganization('');

    //                     navigate('/');
    //                 }
    //             });
    //     } catch (err) {
    //         if (err && err instanceof AxiosError) setError(err);
    //         else if (err && err instanceof Error) setError(err.message);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }, []);

    // const isUserCanSeeLargeFamilies = data?.some((elem) => elem.systemName === 'LargeFamilies');
    // const isUserCanSeeCertificates = data?.some((elem) => elem.systemName === 'Certificates');

    const handleExit = () => {
        localStorage.clear();
        getFioAndOrganization('');
        keycloak.logout({ redirectUri: logoutURL });
    };

    return isLoading ? (
        <LinearProgress />
    ) : (
        <StarryBackground>
            <NebulaEffect />
            {error ? (
                <Typography mt={1} color='error'>
                    Не удалось загрузить доступные вам возможности системы
                </Typography>
            ) : (
                <MenuContainer position='relative' zIndex={10}>
                    <HeaderContainer>
                        <Spacer />

                        <TitleContainer>
                            <Typography
                                color='white'
                                variant='h1'
                                sx={{
                                    fontSize: '48px',
                                    fontWeight: 'bold',
                                    marginRight: '36px',
                                    textShadow: `
                                        0 0 10px rgba(59, 130, 246, 0.5),
                                        0 0 20px rgba(59, 130, 246, 0.3),
                                        0 0 30px rgba(59, 130, 246, 0.2)
                                    `,
                                    animation: 'titleGlow 3s ease-in-out infinite',
                                    '@keyframes titleGlow': {
                                        '0%, 100%': {
                                            textShadow: `
                                                0 0 10px rgba(59, 130, 246, 0.5),
                                                0 0 20px rgba(59, 130, 246, 0.3),
                                                0 0 30px rgba(59, 130, 246, 0.2)
                                            `,
                                        },
                                        '50%': {
                                            textShadow: `
                                                0 0 15px rgba(59, 130, 246, 0.8),
                                                0 0 25px rgba(59, 130, 246, 0.5),
                                                0 0 35px rgba(59, 130, 246, 0.3)
                                            `,
                                        },
                                    },
                                }}
                            >
                                К
                                <IconButton
                                    href={rmiacURL}
                                    target='_blank'
                                    sx={{
                                        padding: 0,
                                        marginBottom: '10px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                            transform: 'scale(1.1)',
                                            cursor: 'pointer',
                                        },
                                    }}
                                >
                                    <img src='/logo-cosmos.svg' alt='custom icon' style={{ width: 50, height: 50 }} />
                                </IconButton>
                                СМОС
                            </Typography>
                        </TitleContainer>

                        <ExitButton onClick={handleExit}>Выход</ExitButton>
                    </HeaderContainer>

                    <SubtitleContainer>
                        <Typography
                            color='rgba(255, 255, 255, 1)'
                            sx={{
                                fontSize: '14px',
                                lineHeight: 1.5,
                                textAlign: 'center',
                            }}
                        >
                            Выберите модуль для работы
                        </Typography>
                    </SubtitleContainer>

                    <StyledGrid>
                        {menuItems.map(({ name, icon, description, url }) => {
                            const isUserCanUseMenuButton = userRoles.some((role) => {
                                return url?.includes(role);
                            });

                            return (
                                <StyledButton
                                    key={name}
                                    onClick={() => {
                                        if (url !== undefined && isUserCanUseMenuButton) {
                                            window.open(url, '_self', 'noopener');
                                        }
                                    }}
                                    disabled={!isUserCanUseMenuButton}
                                >
                                    <Icon color='inherit' sx={{ width: '36px', height: '36px' }}>
                                        {icon}
                                    </Icon>
                                    <Typography
                                        color='white'
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {name}
                                    </Typography>
                                    <Typography
                                        color='rgba(255, 255, 255, 1)'
                                        sx={{
                                            fontSize: '14px',
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        {description}
                                    </Typography>
                                </StyledButton>
                            );
                        })}
                    </StyledGrid>

                    <Typography
                        color='rgba(255, 255, 255, 1)'
                        sx={{
                            fontSize: '14px',
                            textAlign: 'center',
                        }}
                    >
                        © 2025 КОмплексная Система Медицинского Обслуживания и Сопровождения
                    </Typography>
                </MenuContainer>
            )}
        </StarryBackground>
    );
};

export default Main;
